export function isPrimitive(value) {
  // Fast type check for primitives
  const type = typeof value;
  return value === null || 
         value === undefined || 
         type === 'string' || 
         type === 'number' || 
         type === 'boolean' || 
         type === 'bigint' || 
         type === 'symbol' || 
         type === 'function';
}